const Analysis = {
  namespaced: true,

  state: () => ({
    uuid: null,
    name: null,
    created_at: null,
    updated_at: null,
    domain_scan_count: 0,
    average_score: 0,
  }),

  actions: {
    load({ commit }, uuid) {
      return axios.get(`/analyses/${uuid}`)
        .then((response) => {
          commit('setState', { data: response.data });
          return response;
        });
    },

    save({ commit, getters, state }) {
      const method = getters.exists ? 'put' : 'post';

      return axios[method](getters.path, state)
        .then((response) => {
          commit('setState', { data: response.data });
          return response;
        });
    },

    setName({ commit }, value) {
      commit('setProperty', {
        property: 'name',
        value,
      });
    },

    setState({ commit }, value) {
      commit('setProperty', {
        property: 'analysis',
        value,
      });
    },

    clear({ commit }) {
      commit('clear');
    },
  },

  mutations: {
    setProperty(state, { property, value }) {
      state[property] = value;
    },

    setState(state, { data }) {
      for (const property in data) {
        if (Object.prototype.hasOwnProperty.call(state, property)) {
          state[property] = data[property];
        }
      }
    },

    clear(state) {
      for (const property in state) {
        state[property] = null;
      }
    },
  },

  getters: {
    exists(state) {
      return state.uuid !== null;
    },

    path(state) {
      const path = '/analyses/';

      return state.uuid ? path + state.uuid : path;
    },
  },
};

export default Analysis;
